<div [style.margin-top.px]="15" class="table">
  <div class="row">
    <div class="column"></div>
    <div class="column sum">Barn</div>
    <div class="column sum">Bil</div>
    <div class="column"></div>
  </div>

  <div class="row">
    <div class="column"></div>
    <div class="column">{{ this.kalpylator().monthlyChildrenCost }}</div>
    <div
      class="column">{{ this.kalpylator().monthlyCarCost | number: '1.0-0' : 'sv' }}
    </div>
    <div class="column"></div>
  </div>
  <div class="copy-to-right">
    <spb-copy [copy]="copy"></spb-copy>
  </div>
</div>